<template>
  <div id="site-wrapper" :class="{ 'is-touch-device': $store.state.config.isTouchDevice }" @mousedown="test" @touchmove="test2">
    <vue-progress-bar></vue-progress-bar>
    <template v-if="$store.state.config.parking">
      <div id="site-parking">
        <div class="container">
          <header>
            <img src="/static/logo.png" />
          </header>
          <main>
            <h1>
              안녕하십니까?<br/>인슈넷FC 홈페이지를<br/> 새롭게 단장 중입니다.
            </h1>
            <p>리뉴얼 기간동안 보험가입, 계약확인 및 긴급출동, 사고접수 등 문의사항은 인슈넷FC 대표번호 1668-1100으로 연락주시면 확인 가능합니다.</p>
            <p>리뉴얼 기간동안 많은 불편을 드려 죄송합니다. 앞으로도 더 좋은 서비스를 제공하기 위해 항상 노력하는 인슈넷FC가 되겠습니다. 감사합니다.</p>
          </main>
          <footer>
            <div class="temp-button"><a href="tel:1668-1100">1668-1100 전화연결</a></div>
            <div class="temp-button kakao"><a target="_blank" href="http://pf.kakao.com/_qyWZC/chat">카카오톡 플러스친구 채팅상담</a></div>
          </footer>
        </div>
      </div>
    </template>
    <template v-else-if="this.$route.name == 'DenyEmail'">
      <router-view />
    </template>
    <template v-else>

      <site-header  :key="$header_key" :data-key="$header_key"/>
      <div id="site-container">
        <router-view />
      </div>

      <element-modal v-for="key in modalItemsKeys" :elementId="'global' + key" :key="key">
        <component :is="key" />
      </element-modal>
    </template>
    <element-snackbar />
    
    
  </div>
</template>

<script>
import SiteHeader from "@/components/outline/Header";
import { modalItems } from "@/router/routes";
export default {
  components: {
    SiteHeader,
    ...modalItems
  },
  data(){
    return {
      modalItemsKeys: Object.keys( modalItems )
    };
  },
  created () {
    console.log(this.$route.name);
  },
  methods: {
    test (e){
      var chk = false;
      if(e.path){
        e.path.forEach(function (e, i) {
          if(e.className == 'element-combobox') chk = true;
        })
        if(!chk) this.$store.commit('SET_COMBOBOXSTATE', null)
      }
      
    },
    test2 (e){
      var chk = false;
      if(e.path){
        e.path.forEach(function (e, i) {
          if(e.className == 'element-combobox') chk = true;
        })
        if(!chk) this.$store.commit('SET_COMBOBOXSTATE', null)
      }
      
    }
  }
}
</script>
